import React from 'react';
import './App.css';
import { AppProvider, useAppContext } from './context/AppContext';
import { getRandomElementWithoutRepeats } from './utils/madLibUtils';
import templates from './data/templates';
import ErrorBoundary from './components/ErrorBoundary';
import CoverPage from './components/CoverPage';
import WordListPage from './components/WordListPage';
import StoryPage from './components/StoryPage';
import PrintMode from './components/PrintMode';

// Main app component wrapped in context
function AppContent() {
    const { 
        currentPage, 
        currentTemplate, 
        userWords, 
        isTransitioning,
        transitionToPage,
        setUserWords,
        resetApp
    } = useAppContext();

    const handleGenerate = (template) => {
        transitionToPage('wordlist', template);
    };

    const handlePrintMode = (template) => {
        transitionToPage('print', template);
    };

    const handleGenerateNew = () => {
        const newTemplate = getRandomElementWithoutRepeats(templates);
        transitionToPage('wordlist', newTemplate);
    };

    const getNewTemplate = () => {
        return getRandomElementWithoutRepeats(templates);
    };

    const handleWordsSubmit = (words) => {
        setUserWords(words);
        transitionToPage('story');
    };

    const handleBackToCover = () => {
        resetApp();
    };

    return (
        <div className="App">
            <div className={`page-transition ${isTransitioning ? 'transitioning' : ''}`}>
                {currentPage === 'cover' && (
                    <CoverPage 
                        onGenerate={handleGenerate} 
                        onPrintMode={handlePrintMode}
                    />
                )}
                
                {currentPage === 'wordlist' && currentTemplate && (
                    <WordListPage 
                        template={currentTemplate}
                        onSubmit={handleWordsSubmit}
                        onBackToCover={handleBackToCover}
                        onGenerateNew={handleGenerateNew}
                    />
                )}
                
                {currentPage === 'print' && currentTemplate && (
                    <PrintMode 
                        template={currentTemplate}
                        onBackToCover={handleBackToCover}
                        getNewTemplate={getNewTemplate}
                    />
                )}
                
                {currentPage === 'story' && currentTemplate && (
                    <StoryPage 
                        template={currentTemplate}
                        userWords={userWords}
                        onBackToCover={handleBackToCover}
                    />
                )}
            </div>
        </div>
    );
}

// App wrapper with context provider and error boundary
function App() {
    return (
        <ErrorBoundary onRestart={() => window.location.reload()}>
            <AppProvider>
                <AppContent />
            </AppProvider>
        </ErrorBoundary>
    );
}

export default App;